import { lazy } from "react";
import { ScreenLoader } from "../utils/ScreenLoader";
import { AuthGuard } from "../utils/AuthGuard";
import { RoleGuard } from "../contexts/RoleGuard"; // Import RoleGuard

const BetReport = ScreenLoader(lazy(() => import("../screens/BetReport")));

export const BetReportRoute = () => ({
  path: "bet-report",
  element: (
    <AuthGuard>
      <RoleGuard requiredPermission="betReport" requiredActions={["isRead"]}>
        <BetReport />
      </RoleGuard>
    </AuthGuard>
  ),
});
